import { useQuery } from '@tanstack/react-query'
import api from '../api'
import { ApiRouteEnum } from '../../enums/ApiRouteEnum'
import { IContracts } from '../../interfaces/entities/IContracts'
import { IContractDocumentTypes } from '../../interfaces/entities/IContractDocumentTypes'

export const useGetContractDocumentTypes = (contractId: string) => {
  return useQuery(
    [ApiRouteEnum.CONTRACT_DOCUMENT_TYPES, contractId],
    () => api.get<IContractDocumentTypes>(ApiRouteEnum.CONTRACT_DOCUMENT_TYPES.replace('<id>', contractId)),
    { retry: false }
  )
}
